import cx from 'classnames'
import { useContext } from 'react'

import { StringsContext } from '@lib/strings-context'

interface SaleBadgeProps {
  className?: string
}

const SaleBadge = ({ className }: SaleBadgeProps) => {
  const strings = useContext(StringsContext)

  return (
    <div
      className={cx(
        'absolute top-2 right-2 bg-green px-[0.65rem] py-[0.35rem] rounded-full',
        'flex items-center justify-center pointer-events-none select-none',
        className,
      )}
    >
      <span className="text-black text-sm">
        {strings.productOnSaleBadgeText}
      </span>
    </div>
  )
}

export default SaleBadge
